__turbopack_context__.v({
  "className": "b_0Maq_className",
  "variable": "b_0Maq_variable",
});
